var map = {
	"./icon-accommodation.svg": "198e",
	"./icon-arrow.svg": "5d09",
	"./icon-audio.svg": "1880",
	"./icon-blockquote.svg": "e4d4",
	"./icon-burger-close.svg": "fc59",
	"./icon-burger.svg": "0c5e",
	"./icon-chevron.svg": "e5a6",
	"./icon-expand.svg": "efa8",
	"./icon-exploreall.svg": "0a61",
	"./icon-facebook.svg": "431d",
	"./icon-gallery.svg": "096a",
	"./icon-gyro.svg": "c65d",
	"./icon-hs-article.svg": "2873",
	"./icon-hs-audio.svg": "c775",
	"./icon-hs-gallery.svg": "4c8b",
	"./icon-hs-video.svg": "a965",
	"./icon-instagram.svg": "8158",
	"./icon-link.svg": "76f3",
	"./icon-linkedin.svg": "4c08",
	"./icon-marker.svg": "2bdc",
	"./icon-pause-circle.svg": "5423",
	"./icon-play-outline.svg": "c920",
	"./icon-seek-back.svg": "5f93",
	"./icon-seek-forward.svg": "3bc9",
	"./icon-services.svg": "9f5e",
	"./icon-social.svg": "9539",
	"./icon-subjects.svg": "b0a7",
	"./icon-twitter.svg": "5cfb",
	"./icon-video.svg": "1b5f",
	"./icon-vr.svg": "d5a9",
	"./icon-youtube.svg": "63ec",
	"./icon-zoom-in.svg": "bae7",
	"./icon-zoom-out.svg": "54c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a23c";